// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profil-container {
    padding: 24px;
    min-height: 100vh;
}

.profil-container.dark {
    background-color: #141414;
    color: #fff;
}

.profil-card {
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.profil-container.dark .profil-card {
    background-color: #1f1f1f;
    border-color: #434343;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.profil-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 16px 0;
}

.profil-avatar {
    margin-bottom: 16px;
    border: 3px solid #1890ff;
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.profil-name {
    margin: 0 !important;
    font-weight: 600;
}

.clickable-card {
    cursor: pointer;
    transition: all 0.3s ease;
}

.clickable-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.profil-container.dark .clickable-card:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);
}

.card-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}

.card-icon {
    font-size: 20px;
    color: #1890ff;
}

.card-title {
    margin: 0 !important;
    font-weight: 600;
}

.card-preview {
    padding-top: 8px;
}

.document-item {
    padding: 12px;
    border-radius: 8px;
    background-color: #f5f5f5;
    transition: background-color 0.2s;
    border: 1px solid #e8e8e8;
}

.profil-container.dark .document-item,
.dark-modal .document-item,
.profil-container.dark .ant-modal-body .document-item,
.dark-modal .ant-modal-body .document-item {
    background-color: #2a2a2a !important;
    border-color: #434343 !important;
}

.profil-container.dark .document-item .ant-typography,
.dark-modal .document-item .ant-typography,
.profil-container.dark .ant-modal-body .document-item .ant-typography,
.dark-modal .ant-modal-body .document-item .ant-typography {
    color: #fff !important;
}

.profil-container.dark .document-item .ant-typography-caption,
.dark-modal .document-item .ant-typography-caption,
.profil-container.dark .ant-modal-body .document-item .ant-typography-caption,
.dark-modal .ant-modal-body .document-item .ant-typography-caption {
    color: rgba(255, 255, 255, 0.65) !important;
}

.document-item:hover {
    background-color: #e6f7ff;
}

.profil-container.dark .document-item:hover,
.dark-modal .document-item:hover,
.profil-container.dark .ant-modal-body .document-item:hover,
.dark-modal .ant-modal-body .document-item:hover {
    background-color: #1a1a1a !important;
}

/* Table dark mode styles */
.profil-container.dark .ant-table {
    background-color: #1f1f1f;
    color: #fff;
}

.profil-container.dark .ant-table-thead > tr > th {
    background-color: #1f1f1f !important;
    color: #fff !important;
    border-bottom: 1px solid #434343 !important;
}

.profil-container.dark .ant-table-tbody > tr > td {
    background-color: #1f1f1f !important;
    color: #fff !important;
    border-bottom: 1px solid #434343 !important;
}

.profil-container.dark .ant-table-tbody > tr:hover > td {
    background-color: #2a2a2a !important;
}

.profil-container.dark .ant-table-tbody > tr.ant-table-placeholder > td {
    background-color: #1f1f1f !important;
    color: rgba(255, 255, 255, 0.65) !important;
}

.profil-container.dark .ant-table-tbody > tr.ant-table-row > td.ant-table-cell {
    background-color: #1f1f1f !important;
}

.profil-container.dark .ant-table-tbody > tr.ant-table-row:hover > td.ant-table-cell {
    background-color: #2a2a2a !important;
}

.profil-container.dark .ant-table-cell {
    background-color: #1f1f1f !important;
    color: #fff !important;
}

.profil-container.dark .ant-table-cell-fix-left,
.profil-container.dark .ant-table-cell-fix-right {
    background-color: #1f1f1f !important;
}

/* Modal dark mode styles */
.profil-container.dark .ant-modal-content,
.dark-modal .ant-modal-content {
    background-color: #1f1f1f !important;
}

.profil-container.dark .ant-modal-header,
.dark-modal .ant-modal-header {
    background-color: #1f1f1f !important;
    border-bottom: 1px solid #434343 !important;
}

.profil-container.dark .ant-modal-title,
.dark-modal .ant-modal-title {
    color: #fff !important;
}

.profil-container.dark .ant-modal-close,
.dark-modal .ant-modal-close {
    color: rgba(255, 255, 255, 0.65) !important;
}

.profil-container.dark .ant-modal-close:hover,
.dark-modal .ant-modal-close:hover {
    color: #fff !important;
}

.profil-container.dark .ant-modal-body,
.dark-modal .ant-modal-body {
    background-color: #1f1f1f !important;
    color: #fff !important;
}

.dark-modal *,
.profil-container.dark .ant-modal-body * {
    color: inherit;
}

body[data-theme='dark'] .dark-modal .ant-btn-default,
body[data-theme='dark'] .dark-modal .ant-btn-default.ant-btn-sm,
body[data-theme='dark'] .dark-modal .ant-btn-default.ant-btn-small,
body[data-theme='dark'] .dark-modal .document-item .ant-btn-default,
body[data-theme='dark'] .profil-container.dark .ant-modal-body .ant-btn-default,
body[data-theme='dark'] .profil-container.dark .ant-modal-body .document-item .ant-btn-default {
    background-color: #2a2a2a !important;
    border-color: #434343 !important;
    color: #fff !important;
}

body[data-theme='dark'] .dark-modal .ant-btn-default:hover,
body[data-theme='dark'] .dark-modal .ant-btn-default.ant-btn-sm:hover,
body[data-theme='dark'] .dark-modal .ant-btn-default.ant-btn-small:hover,
body[data-theme='dark'] .dark-modal .document-item .ant-btn-default:hover,
body[data-theme='dark'] .profil-container.dark .ant-modal-body .ant-btn-default:hover,
body[data-theme='dark'] .profil-container.dark .ant-modal-body .document-item .ant-btn-default:hover {
    background-color: #3a3a3a !important;
    border-color: #595959 !important;
    color: #fff !important;
}

body[data-theme='dark'] .dark-modal .ant-btn-link,
body[data-theme='dark'] .dark-modal .ant-btn-link.ant-btn-sm,
body[data-theme='dark'] .dark-modal .ant-btn-link.ant-btn-small,
body[data-theme='dark'] .dark-modal .document-item .ant-btn-link,
body[data-theme='dark'] .profil-container.dark .ant-modal-body .ant-btn-link,
body[data-theme='dark'] .profil-container.dark .ant-modal-body .document-item .ant-btn-link {
    background-color: transparent !important;
    border-color: transparent !important;
    color: #1890ff !important;
}

body[data-theme='dark'] .dark-modal .ant-btn-link:hover,
body[data-theme='dark'] .dark-modal .ant-btn-link.ant-btn-sm:hover,
body[data-theme='dark'] .dark-modal .ant-btn-link.ant-btn-small:hover,
body[data-theme='dark'] .dark-modal .document-item .ant-btn-link:hover,
body[data-theme='dark'] .profil-container.dark .ant-modal-body .ant-btn-link:hover,
body[data-theme='dark'] .profil-container.dark .ant-modal-body .document-item .ant-btn-link:hover {
    color: #40a9ff !important;
    background-color: transparent !important;
}

.profil-container.dark .ant-btn-default,
.dark-modal .ant-btn-default,
.profil-container.dark .ant-modal-body .ant-btn-default,
.dark-modal .ant-modal-body .ant-btn-default {
    background-color: #2a2a2a !important;
    border-color: #434343 !important;
    color: #fff !important;
}

.profil-container.dark .ant-btn-default:hover,
.dark-modal .ant-btn-default:hover,
.profil-container.dark .ant-modal-body .ant-btn-default:hover,
.dark-modal .ant-modal-body .ant-btn-default:hover {
    background-color: #3a3a3a !important;
    border-color: #595959 !important;
    color: #fff !important;
}

.profil-container.dark .ant-btn-link,
.dark-modal .ant-btn-link,
.profil-container.dark .ant-modal-body .ant-btn-link,
.dark-modal .ant-modal-body .ant-btn-link {
    color: #1890ff !important;
}

.profil-container.dark .ant-btn-link:hover,
.dark-modal .ant-btn-link:hover,
.profil-container.dark .ant-modal-body .ant-btn-link:hover,
.dark-modal .ant-modal-body .ant-btn-link:hover {
    color: #40a9ff !important;
}

.profil-container.dark .ant-descriptions-item-label {
    color: rgba(255, 255, 255, 0.85);
}

.profil-container.dark .ant-descriptions-item-content {
    color: #fff;
}

.profil-container.dark .ant-descriptions-bordered .ant-descriptions-item-label,
.profil-container.dark .ant-descriptions-bordered .ant-descriptions-item-content {
    border-color: #434343;
}
.profil-container.dark .ant-empty-description {
    color: rgba(255, 255, 255, 0.65);
}

.profil-container.dark .ant-card-head-title {
    color: #fff;
}

.profil-container.dark .ant-tag {
    border-color: #434343;
}

.profil-container.dark .ant-typography {
    color: #fff;
}

.profil-container.dark .ant-typography-caption {
    color: rgba(255, 255, 255, 0.65);
}

.profil-container.dark .ant-input,
.profil-container.dark .ant-input-number,
.profil-container.dark .ant-select-selector,
.dark-modal .ant-input,
.dark-modal .ant-input-number,
.dark-modal .ant-select-selector,
.profil-container.dark .ant-modal-body .ant-input,
.profil-container.dark .ant-modal-body .ant-input-number,
.profil-container.dark .ant-modal-body .ant-select-selector,
.dark-modal .ant-modal-body .ant-input,
.dark-modal .ant-modal-body .ant-input-number,
.dark-modal .ant-modal-body .ant-select-selector {
    background-color: #2a2a2a !important;
    border-color: #434343 !important;
    color: #fff !important;
}

.profil-container.dark .ant-input::placeholder,
.profil-container.dark .ant-input-number::placeholder,
.dark-modal .ant-input::placeholder,
.dark-modal .ant-input-number::placeholder {
    color: rgba(255, 255, 255, 0.3) !important;
}

.dark-modal .document-item .ant-btn,
.profil-container.dark .ant-modal-body .document-item .ant-btn {
    background-color: #2a2a2a !important;
    border-color: #434343 !important;
    color: #fff !important;
}

.dark-modal .document-item .ant-btn:hover,
.profil-container.dark .ant-modal-body .document-item .ant-btn:hover {
    background-color: #3a3a3a !important;
    border-color: #595959 !important;
    color: #fff !important;
}

.dark-modal .document-item .ant-btn-link,
.profil-container.dark .ant-modal-body .document-item .ant-btn-link {
    background-color: transparent !important;
    border-color: transparent !important;
    color: #1890ff !important;
}

.dark-modal .document-item .ant-btn-link:hover,
.profil-container.dark .ant-modal-body .document-item .ant-btn-link:hover {
    color: #40a9ff !important;
}

.profil-container.dark .ant-pagination-item {
    background-color: #2a2a2a;
    border-color: #434343;
}

.profil-container.dark .ant-pagination-item a {
    color: #fff;
}

.profil-container.dark .ant-pagination-item-active {
    background-color: #1890ff;
    border-color: #1890ff;
}

.profil-container.dark .ant-pagination-item-active a {
    color: #fff;
}

.profil-container.dark .ant-pagination-prev,
.profil-container.dark .ant-pagination-next {
    color: #fff;
}

.profil-container.dark .ant-pagination-prev:hover,
.profil-container.dark .ant-pagination-next:hover {
    color: #1890ff;
}

/* Responsive */
@media (max-width: 768px) {
    .profil-container {
        padding: 16px;
    }
    
    .profil-avatar {
        width: 80px !important;
        height: 80px !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/profil/Profil.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA;;;;IAII,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;;;;IAII,sBAAsB;AAC1B;;AAEA;;;;IAII,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;IAII,oCAAoC;AACxC;;AAEA,2BAA2B;AAC3B;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA,2BAA2B;AAC3B;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,oCAAoC;IACpC,2CAA2C;AAC/C;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,2CAA2C;AAC/C;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;;;;;IAMI,oCAAoC;IACpC,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;;;;;;IAMI,oCAAoC;IACpC,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;;;;;;IAMI,wCAAwC;IACxC,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;;;;;;IAMI,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;;;;IAII,oCAAoC;IACpC,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;;;;IAII,oCAAoC;IACpC,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,qBAAqB;AACzB;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;;;;;;;;;;;IAYI,oCAAoC;IACpC,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;;;;IAII,0CAA0C;AAC9C;;AAEA;;IAEI,oCAAoC;IACpC,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;;IAEI,oCAAoC;IACpC,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;;IAEI,wCAAwC;IACxC,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ","sourcesContent":[".profil-container {\n    padding: 24px;\n    min-height: 100vh;\n}\n\n.profil-container.dark {\n    background-color: #141414;\n    color: #fff;\n}\n\n.profil-card {\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    transition: all 0.3s ease;\n}\n\n.profil-container.dark .profil-card {\n    background-color: #1f1f1f;\n    border-color: #434343;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.profil-header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 16px 0;\n}\n\n.profil-avatar {\n    margin-bottom: 16px;\n    border: 3px solid #1890ff;\n    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);\n}\n\n.profil-name {\n    margin: 0 !important;\n    font-weight: 600;\n}\n\n.clickable-card {\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.clickable-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n}\n\n.profil-container.dark .clickable-card:hover {\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);\n}\n\n.card-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.card-icon {\n    font-size: 20px;\n    color: #1890ff;\n}\n\n.card-title {\n    margin: 0 !important;\n    font-weight: 600;\n}\n\n.card-preview {\n    padding-top: 8px;\n}\n\n.document-item {\n    padding: 12px;\n    border-radius: 8px;\n    background-color: #f5f5f5;\n    transition: background-color 0.2s;\n    border: 1px solid #e8e8e8;\n}\n\n.profil-container.dark .document-item,\n.dark-modal .document-item,\n.profil-container.dark .ant-modal-body .document-item,\n.dark-modal .ant-modal-body .document-item {\n    background-color: #2a2a2a !important;\n    border-color: #434343 !important;\n}\n\n.profil-container.dark .document-item .ant-typography,\n.dark-modal .document-item .ant-typography,\n.profil-container.dark .ant-modal-body .document-item .ant-typography,\n.dark-modal .ant-modal-body .document-item .ant-typography {\n    color: #fff !important;\n}\n\n.profil-container.dark .document-item .ant-typography-caption,\n.dark-modal .document-item .ant-typography-caption,\n.profil-container.dark .ant-modal-body .document-item .ant-typography-caption,\n.dark-modal .ant-modal-body .document-item .ant-typography-caption {\n    color: rgba(255, 255, 255, 0.65) !important;\n}\n\n.document-item:hover {\n    background-color: #e6f7ff;\n}\n\n.profil-container.dark .document-item:hover,\n.dark-modal .document-item:hover,\n.profil-container.dark .ant-modal-body .document-item:hover,\n.dark-modal .ant-modal-body .document-item:hover {\n    background-color: #1a1a1a !important;\n}\n\n/* Table dark mode styles */\n.profil-container.dark .ant-table {\n    background-color: #1f1f1f;\n    color: #fff;\n}\n\n.profil-container.dark .ant-table-thead > tr > th {\n    background-color: #1f1f1f !important;\n    color: #fff !important;\n    border-bottom: 1px solid #434343 !important;\n}\n\n.profil-container.dark .ant-table-tbody > tr > td {\n    background-color: #1f1f1f !important;\n    color: #fff !important;\n    border-bottom: 1px solid #434343 !important;\n}\n\n.profil-container.dark .ant-table-tbody > tr:hover > td {\n    background-color: #2a2a2a !important;\n}\n\n.profil-container.dark .ant-table-tbody > tr.ant-table-placeholder > td {\n    background-color: #1f1f1f !important;\n    color: rgba(255, 255, 255, 0.65) !important;\n}\n\n.profil-container.dark .ant-table-tbody > tr.ant-table-row > td.ant-table-cell {\n    background-color: #1f1f1f !important;\n}\n\n.profil-container.dark .ant-table-tbody > tr.ant-table-row:hover > td.ant-table-cell {\n    background-color: #2a2a2a !important;\n}\n\n.profil-container.dark .ant-table-cell {\n    background-color: #1f1f1f !important;\n    color: #fff !important;\n}\n\n.profil-container.dark .ant-table-cell-fix-left,\n.profil-container.dark .ant-table-cell-fix-right {\n    background-color: #1f1f1f !important;\n}\n\n/* Modal dark mode styles */\n.profil-container.dark .ant-modal-content,\n.dark-modal .ant-modal-content {\n    background-color: #1f1f1f !important;\n}\n\n.profil-container.dark .ant-modal-header,\n.dark-modal .ant-modal-header {\n    background-color: #1f1f1f !important;\n    border-bottom: 1px solid #434343 !important;\n}\n\n.profil-container.dark .ant-modal-title,\n.dark-modal .ant-modal-title {\n    color: #fff !important;\n}\n\n.profil-container.dark .ant-modal-close,\n.dark-modal .ant-modal-close {\n    color: rgba(255, 255, 255, 0.65) !important;\n}\n\n.profil-container.dark .ant-modal-close:hover,\n.dark-modal .ant-modal-close:hover {\n    color: #fff !important;\n}\n\n.profil-container.dark .ant-modal-body,\n.dark-modal .ant-modal-body {\n    background-color: #1f1f1f !important;\n    color: #fff !important;\n}\n\n.dark-modal *,\n.profil-container.dark .ant-modal-body * {\n    color: inherit;\n}\n\nbody[data-theme='dark'] .dark-modal .ant-btn-default,\nbody[data-theme='dark'] .dark-modal .ant-btn-default.ant-btn-sm,\nbody[data-theme='dark'] .dark-modal .ant-btn-default.ant-btn-small,\nbody[data-theme='dark'] .dark-modal .document-item .ant-btn-default,\nbody[data-theme='dark'] .profil-container.dark .ant-modal-body .ant-btn-default,\nbody[data-theme='dark'] .profil-container.dark .ant-modal-body .document-item .ant-btn-default {\n    background-color: #2a2a2a !important;\n    border-color: #434343 !important;\n    color: #fff !important;\n}\n\nbody[data-theme='dark'] .dark-modal .ant-btn-default:hover,\nbody[data-theme='dark'] .dark-modal .ant-btn-default.ant-btn-sm:hover,\nbody[data-theme='dark'] .dark-modal .ant-btn-default.ant-btn-small:hover,\nbody[data-theme='dark'] .dark-modal .document-item .ant-btn-default:hover,\nbody[data-theme='dark'] .profil-container.dark .ant-modal-body .ant-btn-default:hover,\nbody[data-theme='dark'] .profil-container.dark .ant-modal-body .document-item .ant-btn-default:hover {\n    background-color: #3a3a3a !important;\n    border-color: #595959 !important;\n    color: #fff !important;\n}\n\nbody[data-theme='dark'] .dark-modal .ant-btn-link,\nbody[data-theme='dark'] .dark-modal .ant-btn-link.ant-btn-sm,\nbody[data-theme='dark'] .dark-modal .ant-btn-link.ant-btn-small,\nbody[data-theme='dark'] .dark-modal .document-item .ant-btn-link,\nbody[data-theme='dark'] .profil-container.dark .ant-modal-body .ant-btn-link,\nbody[data-theme='dark'] .profil-container.dark .ant-modal-body .document-item .ant-btn-link {\n    background-color: transparent !important;\n    border-color: transparent !important;\n    color: #1890ff !important;\n}\n\nbody[data-theme='dark'] .dark-modal .ant-btn-link:hover,\nbody[data-theme='dark'] .dark-modal .ant-btn-link.ant-btn-sm:hover,\nbody[data-theme='dark'] .dark-modal .ant-btn-link.ant-btn-small:hover,\nbody[data-theme='dark'] .dark-modal .document-item .ant-btn-link:hover,\nbody[data-theme='dark'] .profil-container.dark .ant-modal-body .ant-btn-link:hover,\nbody[data-theme='dark'] .profil-container.dark .ant-modal-body .document-item .ant-btn-link:hover {\n    color: #40a9ff !important;\n    background-color: transparent !important;\n}\n\n.profil-container.dark .ant-btn-default,\n.dark-modal .ant-btn-default,\n.profil-container.dark .ant-modal-body .ant-btn-default,\n.dark-modal .ant-modal-body .ant-btn-default {\n    background-color: #2a2a2a !important;\n    border-color: #434343 !important;\n    color: #fff !important;\n}\n\n.profil-container.dark .ant-btn-default:hover,\n.dark-modal .ant-btn-default:hover,\n.profil-container.dark .ant-modal-body .ant-btn-default:hover,\n.dark-modal .ant-modal-body .ant-btn-default:hover {\n    background-color: #3a3a3a !important;\n    border-color: #595959 !important;\n    color: #fff !important;\n}\n\n.profil-container.dark .ant-btn-link,\n.dark-modal .ant-btn-link,\n.profil-container.dark .ant-modal-body .ant-btn-link,\n.dark-modal .ant-modal-body .ant-btn-link {\n    color: #1890ff !important;\n}\n\n.profil-container.dark .ant-btn-link:hover,\n.dark-modal .ant-btn-link:hover,\n.profil-container.dark .ant-modal-body .ant-btn-link:hover,\n.dark-modal .ant-modal-body .ant-btn-link:hover {\n    color: #40a9ff !important;\n}\n\n.profil-container.dark .ant-descriptions-item-label {\n    color: rgba(255, 255, 255, 0.85);\n}\n\n.profil-container.dark .ant-descriptions-item-content {\n    color: #fff;\n}\n\n.profil-container.dark .ant-descriptions-bordered .ant-descriptions-item-label,\n.profil-container.dark .ant-descriptions-bordered .ant-descriptions-item-content {\n    border-color: #434343;\n}\n.profil-container.dark .ant-empty-description {\n    color: rgba(255, 255, 255, 0.65);\n}\n\n.profil-container.dark .ant-card-head-title {\n    color: #fff;\n}\n\n.profil-container.dark .ant-tag {\n    border-color: #434343;\n}\n\n.profil-container.dark .ant-typography {\n    color: #fff;\n}\n\n.profil-container.dark .ant-typography-caption {\n    color: rgba(255, 255, 255, 0.65);\n}\n\n.profil-container.dark .ant-input,\n.profil-container.dark .ant-input-number,\n.profil-container.dark .ant-select-selector,\n.dark-modal .ant-input,\n.dark-modal .ant-input-number,\n.dark-modal .ant-select-selector,\n.profil-container.dark .ant-modal-body .ant-input,\n.profil-container.dark .ant-modal-body .ant-input-number,\n.profil-container.dark .ant-modal-body .ant-select-selector,\n.dark-modal .ant-modal-body .ant-input,\n.dark-modal .ant-modal-body .ant-input-number,\n.dark-modal .ant-modal-body .ant-select-selector {\n    background-color: #2a2a2a !important;\n    border-color: #434343 !important;\n    color: #fff !important;\n}\n\n.profil-container.dark .ant-input::placeholder,\n.profil-container.dark .ant-input-number::placeholder,\n.dark-modal .ant-input::placeholder,\n.dark-modal .ant-input-number::placeholder {\n    color: rgba(255, 255, 255, 0.3) !important;\n}\n\n.dark-modal .document-item .ant-btn,\n.profil-container.dark .ant-modal-body .document-item .ant-btn {\n    background-color: #2a2a2a !important;\n    border-color: #434343 !important;\n    color: #fff !important;\n}\n\n.dark-modal .document-item .ant-btn:hover,\n.profil-container.dark .ant-modal-body .document-item .ant-btn:hover {\n    background-color: #3a3a3a !important;\n    border-color: #595959 !important;\n    color: #fff !important;\n}\n\n.dark-modal .document-item .ant-btn-link,\n.profil-container.dark .ant-modal-body .document-item .ant-btn-link {\n    background-color: transparent !important;\n    border-color: transparent !important;\n    color: #1890ff !important;\n}\n\n.dark-modal .document-item .ant-btn-link:hover,\n.profil-container.dark .ant-modal-body .document-item .ant-btn-link:hover {\n    color: #40a9ff !important;\n}\n\n.profil-container.dark .ant-pagination-item {\n    background-color: #2a2a2a;\n    border-color: #434343;\n}\n\n.profil-container.dark .ant-pagination-item a {\n    color: #fff;\n}\n\n.profil-container.dark .ant-pagination-item-active {\n    background-color: #1890ff;\n    border-color: #1890ff;\n}\n\n.profil-container.dark .ant-pagination-item-active a {\n    color: #fff;\n}\n\n.profil-container.dark .ant-pagination-prev,\n.profil-container.dark .ant-pagination-next {\n    color: #fff;\n}\n\n.profil-container.dark .ant-pagination-prev:hover,\n.profil-container.dark .ant-pagination-next:hover {\n    color: #1890ff;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .profil-container {\n        padding: 16px;\n    }\n    \n    .profil-avatar {\n        width: 80px !important;\n        height: 80px !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
